import { render, staticRenderFns } from "./BusinessTravelDistanceTraveledComponent.vue?vue&type=template&id=80c6576c"
import script from "./BusinessTravelDistanceTraveledComponent.vue?vue&type=script&lang=js"
export * from "./BusinessTravelDistanceTraveledComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports